import { RichTextNode } from '@enview/interface/types/actions/UserAction';

export const nodeHasText = (node: RichTextNode): boolean => {
  // TextNode
  if ('text' in node) {
    return node.text.trim().length > 0;
  }

  // ContainerNode
  if ('children' in node && Array.isArray(node.children)) {
    return node.children.some((n) => nodeHasText(n));
  }

  return false;
};
